import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import FormMultiSelect from '../_shared/forms/FormMultiSelect';
import SubmitButton from '../_shared/SubmitButton';
import axios from 'axios';
import toastr from 'toastr';

export default class ServiceProviderCustomers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedCustomers: this.props.assignedCustomers,
            loading: false,
        };
    }

    handleMultiSelectChange = (value) => {
        this.setState({ selectedCustomers: value });
    };

    onSubmit = (e) => {
        e.preventDefault();

        this.setState({ loading: true });

        const formData = new FormData();
        formData.append('customers', this.state.selectedCustomers ? JSON.stringify(this.state.selectedCustomers) : []);

        axios
            .post(`/providers/${this.props.providerId}/customers`, formData)
            .then(() => {
                toastr.success('Customers saved successfully');
                this.setState({ loading: false });
            })
            .catch((err) => {
                console.log(err);
                toastr.error('There was a problem saving customers');
                this.setState({ loading: false });
            });
    };

    render() {
        return (
            <div>
                <div className="col-12">
                    <form onSubmit={this.onSubmit}>
                        <FormMultiSelect
                            label=""
                            options={this.props.allCustomers}
                            handleMultiSelectChange={this.handleMultiSelectChange}
                            classes="form-control"
                            prefixes={this.state.selectedCustomers}
                        />
                        <SubmitButton
                            buttonText="Save Customers"
                            loading={this.state.loading}
                            style={{ width: 200, marginTop: 20 }}
                        />
                    </form>
                </div>
            </div>
        );
    }
}

// Mount component
if (document.getElementById('provider-customers')) {
    const element = document.getElementById('provider-customers');

    ReactDOM.render(
        <ServiceProviderCustomers
            assignedCustomers={JSON.parse(element.dataset.assignedCustomers)}
            allCustomers={JSON.parse(element.dataset.allCustomers)}
            providerId={element.dataset.providerId}
        />,
        element
    );
}
